import React, { useState } from 'react'
import "../../assets/style/eegisterProvider.css"
import TextField from '@mui/material/TextField';
import { Button, FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import AdminProfileTable from '../../components/Table/adminProfileTable';
import { Link,Outlet,useNavigate, useLocation } from 'react-router-dom';
import Swal from 'sweetalert2';
import ApiCall from '../../utils/Api';
import { toast } from 'react-toastify';

const adminProfile = () => {
    const navigate = useNavigate();
    const location = useLocation()
    const[ButData,setButData]=useState({
     SDL:"" ,
     Instrumente:"",
     TimeModus:"",
     Market:"",
     Time:""
})
const handleChange = (event) => {
     setButData({...ButData,[event.target.name]: event.target.value,});
};
const AddwalletAddress=async()=>{
  try {
     await Swal.fire({
      title: "Add Wallet Address",
      html: `
        <input id="walletid" class="swal2-input">
      `,
      focusConfirm: false,
      preConfirm: async() => {
       
        let Newwalletid=document.getElementById("walletid").value
        const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
        const newwalletid = accounts.filter((item) => item==Newwalletid.toLowerCase())
        if(newwalletid.length==0&&Newwalletid){
        toast.error("This Address is Not Valid Or Your Account is Not Connected")
        return
        }

        const data=await ApiCall.SECURE_API.post("/user/AddWalletAddress",{
          "newWalletAddress": `${Newwalletid}`
      })
      console.log("🚀 ~ preConfirm:async ~ data:", data)
      toast.success(data.data.message)
      
      
      }
    });
  
  } catch (error) {
    console.log("🚀 ~ AddwalletAddress ~ error:", error)
    
  }

}
    console.log('location', location)
    
  return (
    <>
     {location.pathname=="/admin-panel/CheckProviderDetail/RegisterNewDataProvider"||location.pathname=="/admin-panel/CheckProviderDetail/PermissionsDetail"? <Outlet />:<div style={{width:"100%",backgroundColor:"#F3F4F8"}}>
     <span className='RegisterProviderText'>
   <div style={{display:"flex",justifyContent:"space-between"}}>
   <span style={{paddingLeft:20}}>Profile</span> 
   {/* <Button onClick={()=>{
    navigate('/admin-panel/CheckProviderDetail/RegisterNewDataProvider');
   }}  variant="contained">Register New Data Provider</Button>  */}
    </div>     
   

     </span>
            <div style={{display:"flex",flexDirection:"column",alignItems:"center",width:"100%",height:900}}>
              
                            <div style={{width:"98%",marginTop:40}}>
                                <AdminProfileTable/>    
                            </div>   
            </div>
         
</div>}
</>
  )
}

export default adminProfile